import { ChangeEvent, memo } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { DeviceSelected } from "types";
interface HeatmapSingleSensorListProps {
    sensors: DeviceSelected[];
    onChange?: (sensors: DeviceSelected[]) => void;
}

/**
 * Renders a list of sensors in a heatmap format, allowing for sensor removal and chart name updates.
 *
 * @param {HeatmapSingleSensorListProps} props - The component props containing sensors and onChange callback.
 * @returns {JSX.Element} - A JSX element representing the sensor list or an empty fragment if no sensors are present.
 * @throws {Error} - Throws an error if the sensors prop is not an array.
 */
const HeatmapSingleSensorList = ({
    sensors,
    onChange,
}: HeatmapSingleSensorListProps) => {
    const removeSensor = (sensor: DeviceSelected) => {
        const updatedSensors = sensors.filter(
            (item: any) => item.deviceId !== sensor.deviceId
        );

        onChange?.(updatedSensors);
    };

    const handleChangeChartName = (
        event: ChangeEvent<HTMLInputElement>,
        sensor: any
    ) => {
        const updatedSensors = sensors.map((item: any) => {
            if (item.deviceId === sensor.deviceId) {
                return {
                    ...item,
                    chartName: event.target.value,
                };
            }
            return item;
        });

        onChange?.(updatedSensors);
    };

    if (!sensors?.length) {
        return <></>;
    }

    return (
        <Row className="cstm-table heatmap-sensor-table">
            <Col sm={12}>
                <div className="table-head">
                    <Row className="no-checkbox">
                        <Col xs={{ span: 2 }}>Sensor</Col>
                        <Col xs={{ span: 2 }}>Chart Name</Col>
                        <Col xs={{ span: 2 }}>Type</Col>
                        <Col xs={{ span: 2 }}>Gateway</Col>
                        <Col xs={{ span: 2 }}>UUID</Col>
                        <Col xs={{ span: 1 }}> </Col>
                    </Row>
                </div>
                {(sensors || []).map((sensor: any) => (
                    <div className="table-row" key={sensor.deviceId}>
                        <Row className="no-checkbox">
                            <Col xs={{ span: 2 }}>{sensor.sensorName}</Col>
                            <Col xs={{ span: 2 }}>
                                <Form.Control
                                    type="text"
                                    defaultValue={
                                        sensor.chartName ?? sensor.sensorName
                                    }
                                    placeholder=""
                                    onChange={(
                                        event: ChangeEvent<HTMLInputElement>
                                    ) => handleChangeChartName(event, sensor)}
                                />
                            </Col>
                            <Col xs={{ span: 2 }}>{sensor.sensorType}</Col>
                            <Col md={{ span: 2 }}>{sensor.gatewayName}</Col>
                            <Col md={{ span: 2 }}>{sensor.ldsuUID}</Col>
                            <Col md={{ span: 2 }} className="text-right">
                                <Button
                                    variant="link"
                                    className="p-0 text-decoration-none"
                                    onClick={() => removeSensor(sensor)}
                                >
                                    <i className="material-icons close-icon d-flex">
                                        close
                                    </i>
                                </Button>
                            </Col>
                        </Row>
                    </div>
                ))}
            </Col>
        </Row>
    );
};

export default memo(HeatmapSingleSensorList);
